import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";
import { api } from "../lib/api";
import { en } from "../i18n/en";
import { id } from "../i18n/id";
import { pt } from "../i18n/pt";
import { startDomTranslator } from "../i18n/domTranslator";

const DICTS = { en, id, pt };
const LANGS = ["en", "id", "pt"];
const I18nContext = createContext(null);
export const useI18n = () => useContext(I18nContext);

const getInitial = () => {
  try {
    const s = localStorage.getItem("lang");
    if (LANGS.includes(s)) return s;
  } catch {}
  return "en"; // default English
};

export function I18nProvider({ children }) {
  const { user } = useAuth();
  const [lang, setLangState] = useState(getInitial);

  // On login, adopt the account's saved language (account preference wins).
  useEffect(() => {
    const l = user?.language;
    if (LANGS.includes(l) && l !== lang) {
      setLangState(l);
      try { localStorage.setItem("lang", l); } catch {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.language]);

  const setLang = useCallback((l) => {
    if (!LANGS.includes(l)) return;
    setLangState(l);
    try { localStorage.setItem("lang", l); } catch {}
    if (user) { api.put("/auth/language", { language: l }).catch(() => {}); }
  }, [user]);

  useEffect(() => {
    document.documentElement.lang = lang === "pt" ? "pt-BR" : lang;
    return startDomTranslator(lang);
  }, [lang]);

  const t = useCallback((key, vars) => {
    const dict = DICTS[lang] || DICTS.en;
    let s = dict[key];
    if (s == null) s = DICTS.en[key];
    if (s == null) return key;
    if (vars) { for (const k of Object.keys(vars)) s = s.split(`{${k}}`).join(String(vars[k])); }
    return s;
  }, [lang]);

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}
